// extracted by mini-css-extract-plugin
export default {"NavItem":"NavItem_NavItem__nCvSJ","NavItem__Icon":"NavItem_NavItem__Icon__hbfid","NavItem__Label":"NavItem_NavItem__Label__JyUgJ","NavItem__Active":"NavItem_NavItem__Active__02MCO"};